// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.statusLine[data-v-7e3b5cef]
	{
		border-bottom: 2px solid #000000;
		padding: 15px 5px;
}
.statusLine[data-v-7e3b5cef]:last-child
		{
			border-bottom: none;
}
.statusLine .status[data-v-7e3b5cef]
		{
			padding-left: 10px;
			color: #008800;
}
.statusLine.isAlerting .status[data-v-7e3b5cef]
		{
			color: #FF0000;
}
.statusLine.isAlerting[data-v-7e3b5cef]
		{
			font-weight: bold;
			color: #990000;
}
.statusLine[data-v-7e3b5cef]:hover
		{
			background-color: rgba(0,0,0,0.125);
}
.statusLine.mobileLayout[data-v-7e3b5cef]
		{
			flex-direction: column;
			align-items: flex-start;
}
.name[data-v-7e3b5cef]
	{
		flex: 1 1 auto;
		word-break: break-word;
}
.inlineGraph[data-v-7e3b5cef]
	{
		flex: 1 1 auto;
		height: 1em;
}
.details[data-v-7e3b5cef]
	{
		display: flex;
		align-items: center;
		margin-top: 4px;
		justify-content: space-between;
}
.details .inlineGraph[data-v-7e3b5cef]
		{
			flex: 1 1 auto;
			max-width: 250px;
}
@media (min-width: 600px)
	{
.statusLine[data-v-7e3b5cef]
		{
			border-width: 1px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px;
}
.details[data-v-7e3b5cef]
		{
			width: auto;
			margin-top: 0px;
}
.inlineGraph[data-v-7e3b5cef]
		{
			margin: 0px 5px;
			width: 67px;
			height: 1em;
}
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/StatusLine.vue"],"names":[],"mappings":";AAiEC;;EAEC,gCAAgC;EAChC,iBAAiB;AAClB;AAEC;;GAEC,mBAAmB;AACpB;AAEA;;GAEC,kBAAkB;GAClB,cAAc;AACf;AAEA;;GAEC,cAAc;AACf;AAEA;;GAEC,iBAAiB;GACjB,cAAc;AACf;AAEA;;GAEC,mCAAmC;AACpC;AAEA;;GAEC,sBAAsB;GACtB,uBAAuB;AACxB;AAED;;EAEC,cAAc;EACd,sBAAsB;AACvB;AAEA;;EAEC,cAAc;EACd,WAAW;AACZ;AAEA;;EAEC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAC/B;AAEC;;GAEC,cAAc;GACd,gBAAgB;AACjB;AAED;;AAEC;;GAEC,iBAAiB;GACjB,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;GACnB,YAAY;AACb;AAEA;;GAEC,WAAW;GACX,eAAe;AAChB;AAGA;;GAEC,eAAe;GACf,WAAW;GACX,WAAW;AACZ;AACD","sourcesContent":["<template>\r\n\t<div :class=\"{ statusLine: true, isAlerting: isAlerting, mobileLayout: mobileLayout }\" :title=\"jobStatus.AlertState\" @mouseenter=\"onMouseIn\" @mouseleave=\"onMouseOut\">\r\n\r\n\t\t<div class=\"name\">{{jobStatus.Name}}</div>\r\n\t\t<div class=\"details\">\r\n\t\t\t<StatusGraph class=\"inlineGraph\" :jobStatus=\"[jobStatus]\"></StatusGraph>\r\n\t\t\t<div class=\"status\">{{statusText}}</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport EventBus from 'appRoot/scripts/EventBus';\r\n\timport StatusGraph from 'appRoot/vues/client/controls/StatusGraph.vue';\r\n\r\n\texport default {\r\n\t\tcomponents: { StatusGraph },\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tjobStatus: {\r\n\t\t\t\ttype: Object,\r\n\t\t\t\trequired: true\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tisAlerting()\r\n\t\t\t{\r\n\t\t\t\treturn this.jobStatus.AlertState !== null;\r\n\t\t\t},\r\n\t\t\tstatusText()\r\n\t\t\t{\r\n\t\t\t\tif (this.isAlerting)\r\n\t\t\t\t\treturn \"ALERTING\";\r\n\t\t\t\telse\r\n\t\t\t\t\treturn \"OK\";\r\n\t\t\t},\r\n\t\t\tmobileLayout()\r\n\t\t\t{\r\n\t\t\t\treturn EventBus.mobileLayout;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tonMouseIn()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"hoverin\", this.jobStatus);\r\n\t\t\t},\r\n\t\t\tonMouseOut()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"hoverout\", this.jobStatus);\r\n\t\t\t}\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.statusLine\r\n\t{\r\n\t\tborder-bottom: 2px solid #000000;\r\n\t\tpadding: 15px 5px;\r\n\t}\r\n\r\n\t\t.statusLine:last-child\r\n\t\t{\r\n\t\t\tborder-bottom: none;\r\n\t\t}\r\n\r\n\t\t.statusLine .status\r\n\t\t{\r\n\t\t\tpadding-left: 10px;\r\n\t\t\tcolor: #008800;\r\n\t\t}\r\n\r\n\t\t.statusLine.isAlerting .status\r\n\t\t{\r\n\t\t\tcolor: #FF0000;\r\n\t\t}\r\n\r\n\t\t.statusLine.isAlerting\r\n\t\t{\r\n\t\t\tfont-weight: bold;\r\n\t\t\tcolor: #990000;\r\n\t\t}\r\n\r\n\t\t.statusLine:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.125);\r\n\t\t}\r\n\r\n\t\t.statusLine.mobileLayout\r\n\t\t{\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: flex-start;\r\n\t\t}\r\n\r\n\t.name\r\n\t{\r\n\t\tflex: 1 1 auto;\r\n\t\tword-break: break-word;\r\n\t}\r\n\r\n\t.inlineGraph\r\n\t{\r\n\t\tflex: 1 1 auto;\r\n\t\theight: 1em;\r\n\t}\r\n\r\n\t.details\r\n\t{\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tmargin-top: 4px;\r\n\t\tjustify-content: space-between;\r\n\t}\r\n\r\n\t\t.details .inlineGraph\r\n\t\t{\r\n\t\t\tflex: 1 1 auto;\r\n\t\t\tmax-width: 250px;\r\n\t\t}\r\n\r\n\t@media (min-width: 600px)\r\n\t{\r\n\t\t.statusLine\r\n\t\t{\r\n\t\t\tborder-width: 1px;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tpadding: 5px;\r\n\t\t}\r\n\r\n\t\t.details\r\n\t\t{\r\n\t\t\twidth: auto;\r\n\t\t\tmargin-top: 0px;\r\n\t\t}\r\n\r\n\r\n\t\t.inlineGraph\r\n\t\t{\r\n\t\t\tmargin: 0px 5px;\r\n\t\t\twidth: 67px;\r\n\t\t\theight: 1em;\r\n\t\t}\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
